import React from "react";
import { AUTH_BG } from "../../assets";

function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full flex items-start">
      <div className="w-[50%] h-screen flex items-center justify-center">
        {children}
      </div>
      <div className={`w-[50%] h-screen bg-black/50 relative`}>
        <img src={AUTH_BG} className="w-full h-screen object-cover" alt="" />
        <div className="w-full absolute bottom-0 h-[40%]">
          <div
            className="w-full h-full"
            style={{
              background:
                "linear-gradient(0deg, #217834 47.17%, rgba(61, 222, 96, 0) 97.98%)",
              opacity: 0.6,
            }}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-white text-[32px] font-bold text-center">
              Enugu State Customary <br /> Court of Appeal
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
